/* global ROMINGER_PV */

export default {
    BASE_URL: typeof ROMINGER_PV !== 'undefined' ? ROMINGER_PV.ajaxurl : '/wp-admin/admin-ajax.php', // Fallback if localization is not available
    SEND_MESSAGES_URL: typeof ROMINGER_PV !== 'undefined' ? `${ROMINGER_PV.ajaxurl}?action=rominger_send_messages` : '/wp-admin/admin-ajax.php?action=rominger_send_messages',
    EXPORT_PDF_URL: `${typeof ROMINGER_PV !== 'undefined' ? ROMINGER_PV.ajaxurl : '/wp-admin/admin-ajax.php'}?action=rominger_export_pdf`,
    EXPORT_DB_URL: `${typeof ROMINGER_PV !== 'undefined' ? ROMINGER_PV.ajaxurl : '/wp-admin/admin-ajax.php'}?action=rominger_export_db`,
    MESSAGES: {
        ERROR: 'An error occurred.',
        SAVE_SUCCESS: 'Changes saved successfully',
        SAVE_ERROR: 'Failed to save changes: ',
        SEND_ERROR: 'Error sending changes to server: ',
        LOAD_ERROR: 'Error loading data: ',
        NO_DATA_ALLOWED_ERROR: 'No data available for given parameters.',
        ERROR_NO_MISSING_USERS: 'Keine Nutzer mit fehlender Abgabe gefunden.',
        ERROR_MESSAGES: 'Beim Versand der Nachrichten ist ein Fehler aufgetreten.',
        SUCCESS_MESSAGES: 'Nachrichten erfolgreich verschickt.',
    }
};